import kebabCase from 'lodash-es/kebabCase';

const snapgrids = {};
const panels = {};
const datamodels = {};
const vue = {};

const format = name => kebabCase(name);

export const register = cls => {
    if (typeof cls !== 'function' || !cls.__larasnap_type) {
        throw new Error('Only valid larasnap classes can be registered');
    }
    if (!cls.registerAs) {
        throw new Error(
            `All larasnap classes must specify the static 'registerAs' property`,
        );
    }

    const type = cls.__larasnap_type;
    const name = format(cls.registerAs);

    if (type === 'panel') {
        panels[name] = cls;
    } else if (type === 'datamodel') {
        datamodels[name] = cls;
    } else if (type === 'vue') {
        vue[name] = cls;
    } else if (type === 'snapgrid') {
        snapgrids[name] = cls;
    } else {
        throw new Error(
            `Internal error, '__larasnap_type' property is invalid`,
        );
    }
};

export const getPanelClass = name => panels[format(name)];

export const getDataModelClass = name => datamodels[format(name)];

export const getVueClass = name => vue[format(name)];

export const getSnapGridClass = name => snapgrids[format(name)];

const hooks = {
    pageReady: {
        state: false,
        handlers: [],
    },
};

export const onAppReady = f =>
    hooks.pageReady.state ? f() : hooks.pageReady.handlers.push(f);

export const pageReady = () => {
    hooks.pageReady.state = true;
    hooks.pageReady.handlers.forEach(f => f());
};
